import {fetch} from '@/utils/fetch';

/**
 *
 * @param currentPage
 * @param pageSize
 * @param name
 * @param telephone
 * @param email
 * @param permission
 * @returns {Promise}
 */
export function getSalesmanList({ page, size, name, telephone, email, permission }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmen`,
    method: 'get',
    params: {
      page, size, name, telephone, email, permission
    },
  });
}

export function getExportList() {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/downLoad-salesman-company`,
    method: 'get'
  });
}

export function findSalesman(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmen/${ id }`,
    method: 'get',
  });
}

export function saveSalesman(salesmen) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmen`,
    method: 'post',
    data: salesmen,
  });
}

export function updateSalesman(salesmen) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmen`,
    method: 'patch',
    data: salesmen,
  });
}

export function delSalesman(id) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/salesmen/${ id }`,
    method: 'delete',
  });
}

export function findSalesmanCompany(salesmanId) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-salesman-companys/${ salesmanId }`,
    method: 'get',
  });
}

export function saveSalesmanCompany(salesmanId, salesmanCompanyIds) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-salesman-companys/${ salesmanId }`,
    method: 'post',
    data: { companyIds: salesmanCompanyIds }
  });
}

export function getSalesmanCompanyData(salesmanId, { page, size, name }) {
  return fetch({
    url: `${ process.env.VUE_APP_BASE_URL }/biz-salesman-company-data/${ salesmanId }`,
    method: 'get',
    params: {
      page,
      size,
      name,
    },
  });
}
